import { action } from "typesafe-actions";

import { message } from "antd";

import {
  DateRangePayload,
  GatePayload,
  IataPayload,
  OrderingPayload,
  PaginatedResponse,
  PaginationPayload,
  ReportPayload,
  SearchPayload,
} from "../common_types";
import { MarketPayload } from "../markets/types";

import { AirlinesActionTypes, AirlinesItem, AirlinesItemByIata } from "./types";

// Table Actions
export const tableFetchRequest = (
  payload: DateRangePayload & PaginationPayload & MarketPayload & OrderingPayload & GatePayload & SearchPayload
) => action(AirlinesActionTypes.TABLE_FETCH_REQUEST, payload);

export const tableFetchSuccess = (payload: PaginatedResponse<AirlinesItem>) =>
  action(AirlinesActionTypes.TABLE_FETCH_SUCCESS, payload);

export const tableFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AirlinesActionTypes.TABLE_FETCH_ERROR);
};

// Sub-table IATA Actions
export const iataFetchRequest = (
  payload: DateRangePayload & PaginationPayload & MarketPayload & GatePayload & IataPayload
) => action(AirlinesActionTypes.IATA_FETCH_REQUEST, payload);

export const iataFetchSuccess = (payload: { iata: string; items: AirlinesItemByIata[] }) =>
  action(AirlinesActionTypes.IATA_FETCH_SUCCESS, payload);

export const iataFetchError = (errorMessage: string) => {
  message.error(errorMessage);
  return action(AirlinesActionTypes.IATA_FETCH_ERROR);
};

// Report Actions
export const reportGeneratorTaskCreateRequest = (
  payload: ReportPayload & DateRangePayload & MarketPayload & OrderingPayload & GatePayload & SearchPayload
) => action(AirlinesActionTypes.GENERATE_REPORT_REQUEST, payload);
